import { render, staticRenderFns } from "./Prodes2012.vue?vue&type=template&id=0fd39a5b&lang=pug"
import script from "./Prodes2012.vue?vue&type=script&lang=js"
export * from "./Prodes2012.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports